import React from "react";
import { object, bool } from "prop-types";

import LinkTag from "../../molecules/link-tag";
import Headline from "../../atoms/headline";

import { getHeadline } from "../../utils/utils";

import "./customStoryCard5.m.css";

const CustomStoryCard5 = ({ story, isExternalStory }) => (
  <div styleName="wrapper" className="custom-story-card-5">
    <LinkTag href={story.url} styleName="title-wrapper" className="title-wrapper" isExternalStory={isExternalStory}>
      <Headline text={getHeadline(story)} headerType={4} headerLevel={2} story={story} />
    </LinkTag>
  </div>
);

CustomStoryCard5.propTypes = {
  story: object.isRequired,
  isExternalStory: bool,
};

export default CustomStoryCard5;
